import { render, staticRenderFns } from "./tail.vue?vue&type=template&id=3b7db496&scoped=true&"
import script from "./tail.vue?vue&type=script&lang=js&"
export * from "./tail.vue?vue&type=script&lang=js&"
import style0 from "./tail.vue?vue&type=style&index=0&id=3b7db496&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7db496",
  null
  
)

export default component.exports